import { render, staticRenderFns } from "./MobileMiniProgramPrompt.vue?vue&type=template&id=6768552c&"
import script from "./MobileMiniProgramPrompt.vue?vue&type=script&lang=js&"
export * from "./MobileMiniProgramPrompt.vue?vue&type=script&lang=js&"
import style0 from "./MobileMiniProgramPrompt.vue?vue&type=style&index=0&id=6768552c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports